import React from 'react';
import { Box, Container, Grid, Typography, IconButton, Button, Stack, Divider } from '@mui/material';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    { label: 'Software Development', path: '/services/software-development' },
    { label: 'Web Development', path: '/services/web-development' },
    { label: 'Mobile Apps', path: '/services/mobile-apps' },
    { label: 'Cloud Solutions', path: '/services/cloud-solutions' },
    { label: 'AI & Automation', path: '/services/ai-automation' },
    { label: 'UI/UX Design', path: '/services/ui-ux-design' },
    // { label: 'DevOps Services', path: '#' },
  ];

  const company = [
    { label: 'About Us', path: '/about' },
    // { label: 'Careers', path: '/careers' },
    // { label: 'Case Studies', path: '/case-studies' },
    // { label: 'Blog', path: '/blog' },
    { label: 'Contact', path: '/contact' }
  ];

  const resources = [
    // 'Documentation',
    // 'Support Center',
    { label: 'FAQ', path: '/faq' },
    { label: 'Terms of Service', path: '/terms-of-service' },
    { label: 'Privacy Policy', path: '/privacy-policy' }
  ];

  return (
    <Box component="footer" className="footer">
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Box className="footer-company-info">
              <Typography variant="h6" className="footer-logo">
                VIRVES
              </Typography>
              <Typography variant="body2" className="footer-description">
                Empowering businesses with innovative software solutions. We transform ideas into powerful digital experiences that drive growth and success.
              </Typography>
              <Stack direction="row" spacing={1} className="social-icons">
                <IconButton className="social-icon linkedin">
                  <LinkedInIcon />
                </IconButton>
                <IconButton className="social-icon twitter">
                  <TwitterIcon />
                </IconButton>
                <IconButton className="social-icon github">
                  <GitHubIcon />
                </IconButton>
                <IconButton className="social-icon instagram">
                  <InstagramIcon />
                </IconButton>
              </Stack>
            </Box>
          </Grid>

          {/* Services, Company, Resources, Contact - All on same line */}
          <Grid item xs={12} md={8}>
            <Grid container spacing={6}>
              {/* Services */}
              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="subtitle1" className="footer-section-title">
                  Services
                </Typography>
                <ul className="footer-links">
                  {services.map((service) => (
                    <li key={service.label}>
                      <motion.div whileHover={{ x: 5 }} transition={{ duration: 0.2 }}>
                        <Link to={service.path} style={{ textDecoration: 'none', color: 'inherit' }}>
                          {service.label}
                        </Link>
                      </motion.div>
                    </li>
                  ))}
                </ul>
              </Grid>

              {/* Company */}
              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="subtitle1" className="footer-section-title">
                  Company
                </Typography>
                <ul className="footer-links">
                  {company.map((item) => (
                    <li key={item.label}>
                      <motion.div
                        whileHover={{ x: 5 }}
                        transition={{ duration: 0.2 }}
                      >
                        <Link to={item.path} style={{ textDecoration: 'none', color: 'inherit' }}>
                          {item.label}
                        </Link>
                      </motion.div>
                    </li>
                  ))}
                </ul>
              </Grid>

              {/* Resources */}
              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="subtitle1" className="footer-section-title">
                  Resources
                </Typography>
                <ul className="footer-links">
                  {resources.map((resource) => (
                    <li key={typeof resource === 'string' ? resource : resource.label}>
                      {typeof resource === 'object' && resource.path ? (
                        <motion.div whileHover={{ x: 5 }} transition={{ duration: 0.2 }}>
                          <Link to={resource.path} style={{ textDecoration: 'none', color: 'inherit' }}>
                            {resource.label}
                          </Link>
                        </motion.div>
                      ) : (
                        <motion.a
                          href="#"
                          whileHover={{ x: 5 }}
                          transition={{ duration: 0.2 }}
                        >
                          {typeof resource === 'string' ? resource : resource.label}
                        </motion.a>
                      )}
                    </li>
                  ))}
                </ul>
              </Grid>

              {/* Contact */}
              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="subtitle1" className="footer-section-title">
                  Contact Us
                </Typography>
                <ul className="footer-contact">
                  <li>
                    <EmailIcon className="contact-icon" />
                    <a href="mailto:support@virvessoftware.com">support@virvessoftware.com</a>
                  </li>
                  <li>
                    <PhoneIcon className="contact-icon" />
                    <a href="tel:+911294230148">+91 129 423 0148</a>
                  </li>
                  <li>
                    <LocationOnIcon className="contact-icon" />
                    <span>Cinnabar Hills, Embassy Golf Links Business Park, Challaghatta, Bengaluru, Karnataka 560071</span>
                  </li>
                </ul>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Newsletter */}
        <Box className="newsletter-section">
          <Typography variant="h6">
            Stay Updated
          </Typography>
          <Typography variant="body2">
            Subscribe to our newsletter for the latest updates and insights.
          </Typography>
          <Box className="newsletter-form">
            <input type="email" placeholder="Enter your email" />
            <Button variant="contained">
              Subscribe
            </Button>
          </Box>
        </Box>

        <Divider className="footer-divider" />

        {/* Bottom Bar */}
        <Box className="footer-bottom">
          <Typography variant="body2">
            © {currentYear} Virves. All rights reserved.
          </Typography>
          <Stack direction="row" spacing={2} className="bottom-links">
            <motion.div whileHover={{ color: '#3F72AF' }} transition={{ duration: 0.2 }}>
              <Link to="/terms-of-service" style={{ textDecoration: 'none', color: 'inherit' }}>
                Terms
              </Link>
            </motion.div>
            <motion.div whileHover={{ color: '#3F72AF' }} transition={{ duration: 0.2 }}>
              <Link to="/privacy-policy" style={{ textDecoration: 'none', color: 'inherit' }}>
                Privacy
              </Link>
            </motion.div>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 